export default __webpack_public_path__ + "static/media/outdoor.e6615fff.jpg";